var impressum = "Impressum";
var privacy = "Fortrolighed & Jura";
var recallInfo = "Oplysninger vedr. tilbagekaldelse";
var signOut = "Log ud";
var da_dk = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { da_dk as default, impressum, privacy, recallInfo, signOut };
